module.exports = __webpack_public_path__ + "img/template.e2f78024.png";